import { Nominal } from "@common/domain";

export abstract class BaseResponseDTO<T> extends Nominal<T> {
  constructor(readonly value: T) {
    super();
  }
}
